import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable()
export class FormService {
    patchDtoToForm(dtoObject: any, form: FormGroup) {
        if (dtoObject != null) {
            form.reset;
            for (let i in dtoObject) {
                if (dtoObject.hasOwnProperty(i)) {
                    form.patchValue({ [i]: dtoObject[i] });
                }
            }
        }
    }

    patchFormToDto(dtoObject: any, form: FormGroup): any {
        let result = Object.assign({}, dtoObject, form.getRawValue());
        return result;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/services/form.service.ts